<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.projectNo')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.projectNo") }}*</label>
                <vs-input type="text" v-model="form.projectNo" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameEn')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameEn") }}</label>
                <vs-input type="text" v-model="form.nameEn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col flex-1 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        projectNo: '',
        nameTh: '',
        nameEn: '',
        status: 'Enabled'
      }
    }
  },
  async created () {
    await this.getProjects()
    this.pms ('MasterProject', 'create', 'r')
  },
  computed: {
    ...mapMasterFields(['status']),
    ...mapGetters({
      statusesOptions : 'Master/statusesOptions',
      projectOptions : 'Master/projectOptions'
    })
  },
  methods: {
    ...mapMasterActions(['getProjects', 'createProject']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        vm.createProject({
          form: {
            projectNo: vm.form.projectNo,
            nameTh: vm.form.nameTh,
            nameEn: vm.form.nameEn,
            status: vm.form.status.value || vm.form.status
          },
          vm,
          redirect: "/master/project"
        })
      })
    },
    reset () {
      this.form = {
        projectNo: '',
        nameTh: '',
        nameEn: '',
        status: 'Enabled'
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
